import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Input } from "../../../components/Input";
import LeftSide from "../../../components/LeftSide";
import ModalSkeleton from "../../../components/ModalSkeleton";
import ModalAction from "../../../components/ModalAction";
import { TextIcon } from "../../../constant";
import classes from "./AddAnnouncement.module.css";
import clsx from "clsx";
import { DiscountTag } from "../../../constant";
import { toast } from "react-toastify";
// Validation schema
const announcementSchema = Yup.object().shape({
  title: Yup.string()
    .required("Title is required")
    .max(45, "Title cannot exceed 100 characters"),
  notification: Yup.string()
    .required("Short Description is required")
    .max(55, "Short Description cannot exceed 55 characters"),
  data: Yup.string()
    .required("Description is required")
    .max(500, "Description cannot exceed 500 characters"),
});

// Initial values
const initialValues = {
  title: "",
  notification: "",
  data: "",
};

const AddAnnouncement = ({
  show,
  setShow,
  onSubmit,
  isApiCall = false,
  data,
}) => {
  // Initialize formik
  const formik = useFormik({
    initialValues,
    validationSchema: announcementSchema,
    onSubmit: (values, { resetForm }) => {
      if (typeof onSubmit === "function") {
        onSubmit(values);
      }
      resetForm();
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    setValues,
  } = formik;

  // Handle input change with touch
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true);
  };
  console.log("error P", errors);

  useEffect(() => {
    console.log("data in modal", data);
    if (data) {
      const message = JSON.parse(data?.message);
      setValues({
        title: message?.Title,
        notification: message?.Notification,
        data: message?.Data,
      });
    }
  }, [data]);
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      title={`${data ? "Edit" : "Add"} Announcement`}
      width="700px"
    >
      <form onSubmit={handleSubmit}>
        <Row className={classes.controlGrid}>
          <Col xs={12}>
            <Input
              leftIcon={
                <LeftSide icon={<DiscountTag className={classes.icon} />} />
              }
              customStyle={{ gap: "15px" }}
              inputStyle={{ paddingLeft: "0" }}
              labelStyle={{ fontSize: "16px" }}
              label="Title"
              placeholder="Enter announcement title"
              value={values?.title}
              counter={`${values?.title?.length || 0}/45`}
              onChange={(e) => {
                if (e?.length > 45) return;
                handleChangeWithTouch("title")(e);
              }}
              errorText={touched?.title && errors?.title}
            />
          </Col>
          <Col xs={12}>
            <Input
              leftIcon={
                <LeftSide icon={<TextIcon className={classes.icon} />} />
              }
              customStyle={{ gap: "15px" }}
              inputStyle={{ paddingLeft: "0" }}
              labelStyle={{ fontSize: "16px" }}
              label="Short Description"
              placeholder="Enter Short Description"
              value={values?.notification}
              onChange={(e) => {
                if (e?.length > 55) {
                  return;
                }
                handleChangeWithTouch("notification")(e);
              }}
              errorText={touched?.notification && errors?.notification}
              multiline={true}
              counter={`${values?.notification?.length || 0}/55`}
              rows={4}
            />
          </Col>
          <Col xs={12}>
            <Input
              leftIcon={
                <LeftSide icon={<TextIcon className={classes.icon} />} />
              }
              customStyle={{ gap: "15px" }}
              inputStyle={{ paddingLeft: "0" }}
              labelStyle={{ fontSize: "16px" }}
              label="Description"
              placeholder="Enter Description"
              value={values?.data}
              onChange={handleChangeWithTouch("data")}
              errorText={touched?.data && errors?.data}
            />
          </Col>
        </Row>
        <ModalAction
          isApiCall={isApiCall}
          onCancel={() => {
            if (typeof setShow === "function") {
              setShow(false);
            }
          }}
          type="submit"
        />
      </form>
    </ModalSkeleton>
  );
};

export default AddAnnouncement;
